import { render } from "./ajframe.vue?vue&type=template&id=5ad77632"
import script from "./ajframe.vue?vue&type=script&lang=js"
export * from "./ajframe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__